<script lang="ts">	
	import { query } from "$lib/util/url";
	import { KEY_VERTICAL, Vertical } from "$lib/def/verticals";
	import { KEY_DEALS, KEY_FOOD_ITEM, KEY_ITEM_MERCH, KEY_PRIMARY_FILTER, KEY_SEARCH, KEY_SEARCH_FOCUS, KEY_SEARCH_VERTICAL, KEY_SECONDARY_FILTER } from "$lib/serv/food-landing";
	import { RxWritable } from "$lib/util/obs";
	import { onDestroy } from "svelte";
	import { KEY_LANDING_PAGE, KEY_SEARCH_FOUND } from "./FoodLanding.svelte";
	import { KEY_GROUP } from "./food/TileStack.svelte";
	import { KEY_SUB_AISLE } from "./groc/Aisle.svelte";
	import { KEY_TILES } from "./food/Brands.svelte";
	import { debounceTime } from "rxjs";

	import Search from "../form/Search.svelte";

	/**
	 * The current page url. *MUST* get updated when the page changes.
	 */
	export let currentPageUrl: URL;
	
	export let placeholder = 'Search Pick n Pay';

	let searchIn = query(currentPageUrl).get(KEY_SEARCH);
	const search$ = new RxWritable<string | null>(searchIn);

	const searchSub = search$.pipe(
		debounceTime(300),
	).subscribe((search) => {
		const q = query(currentPageUrl);
		const cur = q.get(KEY_SEARCH);
		if (cur !== search) {
			if (search === null) {
				q.remove(KEY_SEARCH, KEY_SEARCH_FOUND).go();
			} else {
				q.set(KEY_SEARCH, search).remove(KEY_SEARCH_FOUND).go({ keepFocus: true, noScroll: true});
			}
		}
	});

	function outputSearch(target?: any | null) {
		search$.set(target?.value ?? '');
	}
	function clearSearchOutput() {
		// if the search param has text clear it with an empty string
		// if the search param is empty clear it with a null
		// const cur = query(currentPageUrl).get(KEY_SEARCH);
		search$.set(''); // the input has a re-focus event the messes up the process
		searchIn = '';
		// query(currentPageUrl).set(KEY_SEARCH, '').go({ keepFocus: true, noScroll: true });
	}

	onDestroy(() => {
		searchSub.unsubscribe();
	});

	const contentAffectSearchParams = [
		KEY_FOOD_ITEM,
		KEY_TILES,
		KEY_SEARCH_FOUND,
		[KEY_SEARCH, KEY_SEARCH_VERTICAL, KEY_SEARCH_FOCUS],
		KEY_LANDING_PAGE,
		KEY_ITEM_MERCH,
		KEY_SECONDARY_FILTER,
		KEY_PRIMARY_FILTER,
		KEY_DEALS,
		KEY_GROUP,
		KEY_SUB_AISLE,
		// KEY_AISLE,
		// BUY_AGAIN,
		// KEY_BANNER,
		// KEY_OCCASION,
	];

	$: isParamed = query(currentPageUrl).hasAny(...contentAffectSearchParams.map(v => Array.isArray(v) ? v[0] : v));
	$: isRoot = currentPageUrl.pathname === '/';
	$: isNotHome = !isRoot || (isRoot && currentPageUrl.searchParams.has(KEY_VERTICAL, Vertical.Grocery));
</script>


<header class="flex-row z-index-2">
	{#if isParamed || isNotHome}
		<div
			onclick={() => window.history.back()}
			onkeypress={e => e.code === 'Escape' ? window.history.back() : null}
			class="button inline-block small tertiary square"
			aria-label="Back"
			role="button"
			tabindex="0"
		>
			<span class="icon-chevron-left-20" style="transform: translateY(6px);"></span>
		</div>
	{/if}

	{#if true}
		<Search
			classes='stretch'
			bind:value={searchIn}
			{placeholder}
			onInput={(e) => outputSearch(e?.target)}
			onFocus={() => outputSearch({ value: $search$ })}
			clear={() => clearSearchOutput()}
			onblur={() => searchIn === '' ? query(currentPageUrl).remove(KEY_SEARCH).go() : null}
		/>
		<!-- onblur={() => query(currentPageUrl).remove(KEY_SEARCH).go()} this causes the search result to keep getting undone -->
	{/if}
</header>

<style lang="scss">
	@use 'layout';
	@use 'screen';
	@use 'color';

	header {
		@include screen.responsive(margin-top, true);
		@include screen.responsive(margin-bottom);
		@include screen.responsive(margin-left, true);
		@include screen.responsive(margin-right, true);

		position: sticky;
		top: layout.$header-height;
		padding: 8px;
		border-bottom: 1px solid color.$separator;
		// top: layout.$header-height;
		// left: menu.$side-nav-width;
		// right: layout.$cart-width;
		// height: 80px;
		background-color: color.$background-elevation-3dp;
		// z-index: 2;
		@media(screen.$md) { border-radius: layout.$block-radius layout.$block-radius 0 0; }

		.button {
			vertical-align: middle;
			margin-right: 8px;
		}

		:global(.search) {
			display: inline-block;
			vertical-align: middle;
		}
	}

	:global(body.has-search) header { display: block; }
</style>
